/* Zydonia: Scroll-Effekte wie auf der Redesign-Startseite für die übrigen Abschnitte (Craft).
   Überschriften fahren Wort für Wort ein, Bilder öffnen sich aus einem Ausschnitt und zoomen auf normale Größe,
   Textblöcke blenden weich ein. Ausgenommen: Produkt-Hauptbereich (Galerie, Kaufbox), Redesign-Abschnitte (.zyx,
   haben eigene Effekte), App-Bereiche. Bei „Bewegung reduzieren“ passiert nichts. */
(function () {
  if (!window.gsap || !window.ScrollTrigger || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const gsap = window.gsap;
  gsap.registerPlugin(window.ScrollTrigger);

  const sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section')).filter(s =>
    !s.querySelector('.zyx, product-info, .product__info-container, [data-zy-cart-page]') &&
    !/__apps|_apps|apps_/.test(s.id) && !s.querySelector('.shopify-app-block, #looxReviews'));
  if (!sections.length) return;

  // Überschrift in Wörter teilen (Masken-Effekt wie auf der Startseite)
  function split(el) {
    const walk = node => {
      Array.from(node.childNodes).forEach(ch => {
        if (ch.nodeType === 3) {
          const frag = document.createDocumentFragment();
          ch.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'zyx-w';
            const wi = document.createElement('span'); wi.className = 'zyx-wi'; wi.textContent = part;
            w.appendChild(wi); frag.appendChild(w);
          });
          node.replaceChild(frag, ch);
        } else if (ch.nodeType === 1 && !/^(BR|SVG|IMG)$/.test(ch.tagName)) walk(ch);
      });
    };
    walk(el);
    return el.querySelectorAll('.zyx-wi');
  }

  const HEADINGS = 'h2, h3.h1, .banner__heading, .rich-text__heading, .image-with-text__heading, .collapsible-content__heading, .title-wrapper h2, .zp-h2, .zp-key';
  const TEXT = '.rich-text__text, .rich-text__buttons, .image-with-text__text, .image-with-text__content > .button, .banner__text, .banner__buttons, .multicolumn-list__item, .collapsible-content .accordion, .collection-list__item, .grid__item .card-wrapper, .zyx-fav__card';

  sections.forEach(sec => {
    sec.querySelectorAll(HEADINGS).forEach(h => {
      if (h.dataset.zyxMotion || !h.textContent.trim() || h.closest('.zyx')) return;
      h.dataset.zyxMotion = '1';
      const words = split(h);
      gsap.fromTo(words, { yPercent: 115 }, { yPercent: 0, duration: 1.25, ease: 'expo.out', stagger: 0.045, scrollTrigger: { trigger: h, start: 'top 88%', once: true } });
    });

    sec.querySelectorAll('img').forEach(img => {
      if (img.dataset.zyxMotion || img.closest('.zyx, .zyx-fav__media, .zyx-gift-img, .zyx-addon__img')) return;
      const r = img.getBoundingClientRect();
      if (r.width < 200 && img.width < 200) return; // Symbole und kleine Bilder nicht
      img.dataset.zyxMotion = '1';
      const box = img.closest('.media, .banner__media, .image-with-text__media, .multicolumn-card__image-wrapper, .card__media, figure') || img.parentElement;
      box.style.overflow = 'hidden';
      gsap.fromTo(box, { clipPath: 'inset(14% 6% 14% 6%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.6, ease: 'expo.out', scrollTrigger: { trigger: box, start: 'top 85%', once: true } });
      gsap.fromTo(img, { scale: 1.18 }, { scale: 1, duration: 1.9, ease: 'expo.out', scrollTrigger: { trigger: box, start: 'top 85%', once: true } });
    });

    // Favoriten-Raster: Bilder der Karten ebenfalls öffnen
    sec.querySelectorAll('.zyx-fav__media').forEach(box => {
      const img = box.querySelector('img');
      gsap.fromTo(box, { clipPath: 'inset(10% 8% 10% 8%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.5, ease: 'expo.out', scrollTrigger: { trigger: box, start: 'top 88%', once: true } });
      if (img) gsap.fromTo(img, { scale: 1.15 }, { scale: 1, duration: 1.8, ease: 'expo.out', scrollTrigger: { trigger: box, start: 'top 88%', once: true } });
    });

    sec.querySelectorAll(TEXT).forEach((el, i) => {
      if (el.dataset.zyxMotion) return;
      el.dataset.zyxMotion = '1';
      gsap.fromTo(el, { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 1.1, ease: 'expo.out', delay: (i % 3) * 0.08, scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
    });
  });

  // Bilder und Apps laden nach: Positionen nachziehen
  window.addEventListener('load', () => window.ScrollTrigger.refresh());
})();
